import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { GroupId, GroupSharedState } from "@pulse-ui/widget-sdk";

interface GroupsState {
  groups: Partial<Record<GroupId, GroupSharedState>>;
}

// Structural selector type avoids circular dependency with @/store
type StateWithGroups = { groups: GroupsState };

const initialState: GroupsState = {
  groups: {
    default: {},
  },
};

const groupsSlice = createSlice({
  name: "groups",
  initialState,
  reducers: {
    updateGroupState(
      state,
      action: PayloadAction<{ groupId: GroupId; state: GroupSharedState }>
    ) {
      state.groups[action.payload.groupId] = action.payload.state;
    },
  },
});

export const { updateGroupState } = groupsSlice.actions;

export const selectAllGroupStates = (state: StateWithGroups) => state.groups.groups;

export default groupsSlice.reducer;
